import { ISalesContactsModel } from "@app/shared/shared.models";
import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";

export const salesContactsAdapter: EntityAdapter<(ISalesContactsModel)> = createEntityAdapter<ISalesContactsModel>({
	selectId: contacts => contacts.accountId,
});